import React, { useEffect, useState } from "react";
import SCDropdown from "./form/dropdown/SCDropdown";
import api from "../services/api";

type Props = any;

const SelectColaborador: React.FC<Props> = ({
  name,
  control,
  errors,
  label,
  ...props
}) => {
  const [lista, setLista] = useState<any>([]);

  useEffect(() => {
    let isMounted = true;
    api
      .get("/funcionarios/list")
      .then(({ data }) => {
        if (isMounted) setLista(data);
      })
      .catch((error) => {
        console.log("Erro ao carregar colaboradores", error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <SCDropdown
      name={name}
      label={label}
      control={control}
      errors={errors}
      options={lista}
      optionLabel="Nome"
      optionValue="FuncionarioId"
      {...props}
    />
  );
};

export default SelectColaborador;
